var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5a.5.5 0 110 1 .5.5 0 010-1z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 2.707a1 1 0 011.414 0l8.586 8.586a1 1 0 010 1.414l-9 9a1 1 0 01-.707.293H3a1 1 0 01-1-1v-8.586a1 1 0 01.293-.707l9-9zM7 15a2 2 0 100 4 2 2 0 000-4z",
    fill: "currentColor"
  })));
}
SvgBrandedFilled.displayName = 'BrandedFilled';
export default SvgBrandedFilled;